<div class="results mt-5">
  <div class="d-flex align-items-md-center flex-column flex-md-row">
    <h2 class="mb-2 txt txt--section txt--grey">Resultados</h2>
    <p *ngIf="detailInfractionsByFilter.length > 0" class="mb-1 ml-md-2 txt txt--paragraph  txt--grey js-show">({{detailInfractionsByFilter.length}} infracciones)</p>

  </div>
  <p  *ngIf="detailInfractionsByFilter.length < 1" class="mt-1 mt-md-0 txt txt--paragraph txt--grey js-show">No se han encontrado resultados con la búsqueda, por favor intentar con filtros diferentes.</p>
  <!-- <p class="mt-1 mt-md-0 txt txt--paragraph txt--grey js-show">MEL - Del 01/01/2020 al 01/01/2021 - Todas las
    solicitudes</p> -->
    <div *ngIf="detailInfractionsByFilter.length > 0" class="js-show">
        <div class="mt-2 mt-lg-5 table-overflow">
            <table class="table">
                <thead>
                    <tr>
                        <th class="hover-hand" >
                            <div class="table-head headerTable">
                            <p>Asset</p>
                           

                            </div>
                        </th>
                        <th class="th hover-hand">
                            <div class="table-head headerTable">
                            <p>Nombre conductor</p>
                          

                            </div>
                        </th>
                        <th class="th hover-hand">
                            <div class="table-head headerTable">
                            <p>Zonas registradas</p>
                       

                            </div>
                        </th>
                        <th class="th hover-hand" >
                            <div class="table-head headerTable">
                            <p>Severidad</p>
                          

                            </div>
                        </th>
                        <th class="th hover-hand">
                            <div class="table-head headerTable">
                            <p>Sanción</p>
                         

                            </div>
                        </th>
                        <th class="th hover-hand" >
                            <div class="table-head headerTable">
                            <p>Fecha emisión</p>
                        

                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let itemDetail of detailInfractionsByFilter ; let i = index ">
                        <td>{{itemDetail.asset}}</td>
                        <td>{{itemDetail.driverName}}</td>
                        <td>{{itemDetail.registeredZone}}</td>
                        <td>{{itemDetail.severity}}</td>
                        <td>{{itemDetail.sanction}}</td>
                        <td>{{itemDetail.dateOfIssue | date: 'dd/MM/yyyy'}}</td>

                    </tr>

                </tbody>
            </table>
        </div>
        <div class="u-mt30">
            <button type="button" class="btn btn--primary" (click)="export()">Descargar reporte completo</button>
        </div>
    </div>
</div>
